import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  Switch: {
    position: 'absolute',
    bottom: 62,
    left: 57,
    zIndex: 1001,
  },
}));

export { useStyles };
